import React, { ReactNode } from 'react';
import { JucyToastContainer } from '@jucy-ui/components';
import Box from '@mui/material/Box';

interface AppProps<Component extends React.ElementType> {
    layout: Component;
    layoutProps?: React.ComponentPropsWithoutRef<Component>;
    children?: ReactNode;
    altBg?: boolean;
}

const App: <Component extends React.ElementType>(p: AppProps<Component>) => React.ReactElement<AppProps<Component>> = ({
    children,
    layout: Layout,
    layoutProps,
    altBg,
}) => {
    const Component = Layout as React.ComponentType<{ children?: ReactNode }>;
    return (
        <Box
            component="main"
            sx={(theme) => ({
                display: 'flex',
                alignItems: 'stretch',
                flexDirection: 'column',
                minHeight: '100%',
                minWidth: 0,
                ...(altBg ? { background: theme.palette.grey[100] } : undefined),
            })}
        >
            <Component {...layoutProps}>{children}</Component>
            <JucyToastContainer position="bottom-center" />
        </Box>
    );
};

export default App;
